import { Box, Button, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { TypographyOptions } from "@mui/material/styles/createTypography";

interface ButtonProps {
  className?: string;
  title?: string;
  description?: string;
  loading?: boolean;
  width?: string;
  height?: string;
  bgColor?: string;
  rippleColor?: string;
  fSize?: string;
  fWeight?: string;
  fFamily?: string;
  icon1?: JSX.Element | boolean;
  icon2?: JSX.Element | boolean;
  border?: string;
  borderColor?: string;
  boxShadow?: string;
  px?: string;
  py?: string;
  borderRadius?: string;
  mt?: string;
  mr?: string;
  mb?: string;
  ml?: string;
  onClick?: () => void;
  justifyContent?: string;
  flexDirection?: string;
  disabled?: boolean;
  notAllow?: boolean;
  disableRipple?: boolean;
  disableShadow?: boolean;
  type?: "outlined" | "contained";
  textColor?: string;
  flex?: 1 | 0;
  gap?: string;
}

const CustomButton = (props: ButtonProps) => {
  const {
    className,
    flex = 0,
    gap = "6px",
    textColor = "#ffffff",
    rippleColor = "#fff",
    type = "contained",
    title,
    description,
    loading = false,
    width = "auto",
    height = "auto",
    bgColor = "primary.main",
    fSize = "14px",
    fWeight = "600",
    fFamily = "YekanBakh",
    icon1,
    icon2,
    border = "none",
    borderColor = "",
    boxShadow = "none",
    px = "10px",
    py = "10px",
    borderRadius = "10px",
    mt = "0px",
    mr = "0px",
    mb = "0px",
    ml = "0px",
    onClick,
    justifyContent = "start",
    flexDirection = "space-between",
    disabled = false,
    notAllow = false,
    disableRipple = false,
    disableShadow = false,
  } = props;

  const keyframes = `
  @keyframes borderBA {
    0% {
      bottom:0px;
      right:0px;
    }
    25% {
    opacity:0;
      right:50%;
      bottom:0px;

    }
  }
    @keyframes borderBL {
    from {
      left:0px;
      bottom:0;
    }
    to {
      left:0px;
      bottom:50%;

    }
  }
`;

  return (
    <Button
      // className={className}
      variant="contained"
      onClick={onClick}
      disabled={disabled || loading}
      disableRipple={disableRipple}
      disableElevation={disableShadow}
      startIcon={loading && <CircularProgress size={24} color="inherit" />}
      sx={{
        position: "relative",
        flex: flex,
        lineHeight: "normal",
        display: "flex",
        justifyContent: "center",
        alignItems: "start",
        flexDirection: "column",
        width: width,
        minWidth: width,
        height: height,
        bgcolor: bgColor,
        fontSize: fSize,
        px: px,
        py: py,
        borderColor: borderColor,
        borderWidth: "1px",
        borderStyle: "solid",
        border: borderColor ? "" : "none",
        boxShadow: boxShadow,
        borderRadius: borderRadius,
        mt: mt,
        mr: mr,
        mb: mb,
        ml: ml,
        cursor: notAllow ? "not-allowed" : "pointer",
        "& .MuiTouchRipple-root": {
          color: `${rippleColor} !important`,
          borderWidth: "0px !important",
        },
        "& .MuiCircularProgress-svg": {
          color: bgColor,
          mx: "auto",
        },
        "& .MuiButton-startIcon": {
          margin: "auto !IMPORTANT",
        },

        // "&.MuiButtonBase-root::after": {
        //   content: '""', // Ensures the pseudo-element is visible
        //   position: "absolute",

        //   bottom: "0px",
        //   // left: "0px",
        //   width: "2px",
        //   height: "50%", // Added height to make the pseudo-element visible
        //   // background: "rgb(23,131,240)",
        //   background: `linear-gradient(90deg, rgba(23,131,240,1) 0%, rgba(255,255,255,1) 100%)`,
        //   // borderRadius: "100px",
        //   animation: `borderBL forwards 0.3s infinite`,
        //   animationTimingFunction: "linear",
        // },
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // "&.MuiButtonBase-root::after": {
        //   content: '""', // Ensures the pseudo-element is visible
        //   position: "absolute",

        //   bottom: "0px",
        //   // left: "0px",
        //   width: "50%",
        //   height: "2px", // Added height to make the pseudo-element visible
        //   // background: "rgb(23,131,240)",
        //   background: `linear-gradient(90deg, rgba(23,131,240,1) 0%, rgba(255,255,255,1) 100%)`,
        //   // borderRadius: "100px",
        //   animation: `borderBA forwards 0.3s infinite`,
        //   animationTimingFunction: "linear",
        // },

        "&.MuiButtonBase-root:hover": {
          bgcolor: !disabled ? bgColor : "",
          borderColor: borderColor,
          borderWidth: "1px",
          borderStyle: "solid",
          border: borderColor ? "" : "none",
          opacity: 0.92,
        },
      }}
    >
      <style>{`
      .animateButton::after{
      content: '';
      position:absolute;
      bottom:0px;
      left:0px;
      height:2px;
      width:50%;
      background:linear-gradient(90deg, rgba(23,131,240,1) 0%, rgba(255,255,255,1) 100%);
      animation: borderBA forwards 1s infinite;
            }
      
      
      
      ${keyframes}
      
      `}</style>
      {!loading && (
        <>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: flexDirection,
              justifyContent: justifyContent,
              alignItems: "center",
              gap: gap,
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: gap,
                alignItems: "center",
              }}
            >
              {icon1 && icon1}
              <Typography
                noWrap
                sx={{
                  fontSize: fSize,
                  fontFamily: fFamily,
                  fontWeight: fWeight,
                  color: textColor,
                }}
              >
                {title && title}
              </Typography>
            </Box>
            {icon2 && <Box>{icon2}</Box>}
          </Box>
          {description && (
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "600",
              }}
            >
              {description}
            </Typography>
          )}
        </>
      )}
    </Button>
  );
};

export default CustomButton;
